module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Start":"Start","Pause":"Pause","Resume":"Resume","Please turn your camera or mic on.":"Please turn your camera or mic on."},"zh":{"Start":"开始直播","Pause":"暂停直播","Resume":"继续直播","Please turn your camera or mic on.":"请开启摄像头或麦克风"}}')
  delete Component.options._Ctor
}
